import type { DriverTab } from '../drivers.paths';

/** The ledger and devices tabs exist only for roles that may see them; a link to one sends everyone else to Details. */
export function isDriverTabHidden(tab: DriverTab, access: { canManageDevices: boolean; canViewLedger: boolean }): boolean {
  if (tab === 'devices') return !access.canManageDevices;
  if (tab === 'ledger') return !access.canViewLedger;
  return false;
}
